import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useExpenseInvoiceContext } from "../../context/ExpenseInvoiceContext";
import "./expenseInvoiceForm.css";

const ExpenseInvoiceForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = !!id;

  const {
    createExpenseInvoice,
    updateExpenseInvoice,
    fetchExpenseInvoice,
    loading,
  } = useExpenseInvoiceContext();

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    amount: "",
    created_at: new Date().toISOString().split("T")[0],
  });

  useEffect(() => {
    if (isEditMode) {
      loadInvoice();
    }
  }, [id]);

  const loadInvoice = async () => {
    try {
      const invoice = await fetchExpenseInvoice(id);
      if (invoice) {
        setFormData({
          title: invoice.title,
          description: invoice.description || "",
          amount: invoice.amount,
          created_at: invoice.created_at,
        });
      }
    } catch (err) {
      console.error("Error loading invoice:", err);
      alert("حدث خطأ أثناء تحميل بيانات الفاتورة");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title.trim()) {
      alert("⚠️ العنوان مطلوب");
      return;
    }

    if (!formData.amount || parseFloat(formData.amount) <= 0) {
      alert("⚠️ المبلغ يجب أن يكون أكبر من صفر");
      return;
    }

    const invoiceData = {
      title: formData.title.trim(),
      description: formData.description.trim() || null,
      amount: parseFloat(formData.amount),
      created_at: formData.created_at,
    };

    if (isEditMode) {
      invoiceData.id = parseInt(id);
    }

    try {
      const response = isEditMode
        ? await updateExpenseInvoice(invoiceData)
        : await createExpenseInvoice(invoiceData);

      if (response.status === "success") {
        alert(
          `✅ ${
            isEditMode
              ? "تم تحديث فاتورة الصرف بنجاح"
              : "تم إضافة فاتورة الصرف بنجاح"
          }`
        );
        navigate("/expense-invoices");
      }
    } catch (err) {
      console.error("Error saving invoice:", err);
      alert(
        err.response?.data?.message ||
          `حدث خطأ أثناء ${isEditMode ? "تحديث" : "إضافة"} فاتورة الصرف`
      );
    }
  };

  return (
    <div className="expense-invoice-form-page">
      <div className="form-container">
        <h1 className="page-title">
          {isEditMode ? "تعديل فاتورة صرف" : "إضافة فاتورة صرف جديدة"}
        </h1>

        <form onSubmit={handleSubmit} className="invoice-form">
          <div className="form-group">
            <label htmlFor="title">
              العنوان <span className="required">*</span>
            </label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="مثال: كهرباء، مياه، راتب موظف..."
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="amount">
              المبلغ (₪) <span className="required">*</span>
            </label>
            <input
              type="text"
              id="amount"
              name="amount"
              value={formData.amount}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9.]/g, "");
                handleChange({ target: { name: "amount", value } });
              }}
              placeholder="0.00"
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="created_at">
              التاريخ <span className="required">*</span>
            </label>
            <input
              type="date"
              id="created_at"
              name="created_at"
              value={formData.created_at}
              onChange={handleChange}
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">الوصف</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="أدخل تفاصيل إضافية (اختياري)..."
              rows="4"
              className="form-textarea"
            />
          </div>

          <div className="form-actions">
            <button type="submit" className="btn-submit" disabled={loading}>
              {loading
                ? "جارٍ الحفظ..."
                : isEditMode
                ? "💾 حفظ التعديلات"
                : "➕ إضافة فاتورة الصرف"}
            </button>
            <Link to="/expense-invoices" className="btn-cancel">
              إلغاء
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ExpenseInvoiceForm;
